// Packages
import { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Context
import { useUI } from 'context/UI'
import { useSnackbar } from 'context/Snackbar'

// Other
import Config from 'other/config';


const useApi = (url, runGet=true ) => {

	const [ data, setData ] = useState([])
	const [ meta, setMeta ] = useState([])
	const [ isLoading, setIsLoading ] = useState(false)
	const [ isError, setIsError ] = useState(true)
	const [ errors, setErrors ] = useState({})
    const [ errorCode, setErrorCode] = useState()
	const [ refresh, setRefresh ] = useState(false)
    const [params, setParams] = useState('');

	const { setLoading } = useUI();
    const { showSnackbar } = useSnackbar();

    const navigate = useNavigate();

    /**	
     * Return the access token from local storage
     */
    const getAccessToken = async () => {

        return localStorage.getItem('access-token');
    }

    /**
     * Error handler
     */
    useEffect(() => {

        if ( errorCode === 401 )
        {
            redirectToAuth()
        }

    }, [errorCode])

    /**
     * Redirect to Auth
     */
    const redirectToAuth = () => {
        navigate('/login?redirect=' + window.location.pathname);
    }


	useEffect(() => 
	{
        if( runGet ) {

            setLoading(true);
            setIsLoading(true);

            const fetchData = async () => {

                const token = await getAccessToken();

                try {

                    const response = await axios.get(Config.API_URL + url + params, {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    })
                        
                    setData(response.data.data);
                    setMeta(response.data.meta);

                    setIsError(false);
                    setIsLoading(false);


                } catch (error) {
                    setIsError(true);
                    setErrors(error.response.data.errors);
                    setErrorCode(error.response.status)
                    showSnackbar(error.response.data.message, 'error');

                }
                
                setLoading(false);
            }

            fetchData();
        }

	}, [url, refresh, params])


    const get = async (successMessage) => 
	{
        setIsLoading(true);
        setLoading(true);

        try 
        {
            const token = await getAccessToken();

            const response = await axios.get(Config.API_URL + url, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            });

            setData(response.data.data);

            setIsError(false);
            setIsLoading(false)

            showSnackbar(successMessage, 'success');
            
            setIsLoading(false);
            setLoading(false);

            return response.data.data;
        } 
        catch (error) 
        {
            setIsError(true);
            setErrors(error.response.data.errors);
            setErrorCode(error.response.status)
            showSnackbar(error.response.data.message, 'error');

            setIsLoading(false);
            setLoading(false);

            return false;
        }
    };

	const put = async (postData, successMessage) => 
	{
        setIsLoading(true);
        setLoading(true);

        const token = await getAccessToken();

        try 
        {
            const response = await axios.put(Config.API_URL + url, postData, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            });

            setData(response.data.data);

            setIsError(false);
            setIsLoading(false)

            showSnackbar(successMessage, 'success');
            
            setIsLoading(false);
            setLoading(false);

            return response.data.data;
        } 
        catch (error) 
        {
            setIsError(true);
            setErrors(error.response.data.errors);
            setErrorCode(error.response.status)
            showSnackbar(error.response.data.message, 'error');

            setIsLoading(false);
            setLoading(false);

            return false;
        }

        
    };

    const post = async (postData, successMessage, redirect) => 
    {
        setIsLoading(true);
        setLoading(true);

        const token = await getAccessToken();

        try 
        {
            const response = await axios.post(Config.API_URL + url, postData, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            });


            if( successMessage ) {

                showSnackbar(successMessage, 'success');
            }
            
            setData(response.data.data);

            setIsError(false);
            setIsLoading(false);
            setLoading(false);

            if( redirect ) {

                navigate(redirect + response.data.data.id);
            }

            return response.data.data;

        } 
        catch (error) 
        {
            setIsError(true);
            setErrors(error.response.data.errors);
            setErrorCode(error.response.status)
            showSnackbar(error.response.data.message, 'error');
            setIsLoading(false);
            setLoading(false);

            return false;
        }
        
    };


    const destroy = async (itemType, successMessage) => 
    {
        if ( ! window.confirm('Are you sure that you want to remove this '+ itemType + '?') )
        {
            return false;
        }

        setIsLoading(true);
        setLoading(true);

        const token = await getAccessToken();

        try 
        {
            const response = await axios.delete(Config.API_URL + url, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            });

            setData(response.data.data);
            setIsError(false);
            setIsLoading(false)

            showSnackbar(successMessage, 'success');

            setIsLoading(false);
            setLoading(false);

            return true;
            
        } 
        catch (error) 
        {
            setIsError(true);
            setErrors(error.response.data.errors);
            setErrorCode(error.response.status)
            showSnackbar(error.response.data.message, 'error');

            setIsLoading(false);
            setLoading(false);
            return false;
        }

    };

    const onChange = useCallback(() => {
        setRefresh(prevRefresh => !prevRefresh);
    }, []);

	return { 
        data,
        meta,
		isLoading, 
		isError, 
        errors,
        get,
		put, 
		post,
        destroy,
        onChange,
        setParams
	}
}

export default useApi